import { Resource } from './resource';
import { Filter } from './filters';
import { Sort, SortDirection, SortColumn } from './sort';
import { MultiPointInstallation, Organization } from './api';

export type MultiPointInstallationListState = {
  selectedMultiPointInstallationIds: Array<MultiPointInstallation['id']>;

  sidePaneMultiPointInstallationId: MultiPointInstallation['id'] | null;

  filters: Array<Filter>;
  searchText: string;
  sort: {
    direction: 'none' | 'desc' | 'asc';
    column: null | string;
  };

  page: number;

  resource: Resource<{
    items: Array<MultiPointInstallation>;
    total: number;
    m2m_capture_group_enabled: boolean;
    fetchingMoreMPIs: Resource<null>;
  }>;
};

export enum MultiPointInstallationListActionTypes {
  MULTI_POINT_INSTALLATION_LIST_CHANGE_PAGE = 'MULTI_POINT_INSTALLATION_LIST_CHANGE_PAGE',

  MULTI_POINT_INSTALLATION_LIST_LOADING = 'MULTI_POINT_INSTALLATION_LIST_LOADING',
  MULTI_POINT_INSTALLATION_LIST_ERROR = 'MULTI_POINT_INSTALLATION_LIST_ERROR',
  MULTI_POINT_INSTALLATION_LIST_LOAD_COMPLETE = 'MULTI_POINT_INSTALLATION_LOAD_LIST_COMPLETE',

  MULTI_POINT_INSTALLATION_LIST_SET_SEARCH_TEXT = 'MULTI_POINT_INSTALLATION_LIST_SET_SEARCH_TEXT',
  MULTI_POINT_INSTALLATION_LIST_SET_FILTERS = 'MULTI_POINT_INSTALLATION_LIST_SET_FILTERS',
  MULTI_POINT_INSTALLATION_LIST_SET_SORT = 'MULTI_POINT_INSTALLATION_LIST_SET_SORT',
  MULTI_POINT_INSTALLATION_LIST_CHANGE_CHECKS = 'MULTI_POINT_IN_LISTSTALLATION_CHANGE_CHECKS',

  MULTI_POINT_INSTALLATION_LIST_OPEN_SIDE_PANE = 'MULTI_POINT_INSTALLATION_LIST_OPEN_SIDE_PANE',
  MULTI_POINT_INSTALLATION_LIST_CLOSE_SIDE_PANE = 'MULTI_POINT_INSTALLATION_LIST_CLOSE_SIDE_PANE',

  MULTI_POINT_INSTALLATION_LIST_DELETE = 'MULTI_POINT_INSTALLATION_LIST_DELETE',

  MULTI_POINT_INSTALLATION_LIST_SET_PAGE = 'MULTI_POINT_INSTALLATION_LIST_SET_PAGE',
  MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_LOADING = 'MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_LOADING',
  MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_ERROR = 'MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_ERROR',
  MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_COMPLETE = 'MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_COMPLETE',
}

export type MultiPointInstallationListAction =
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_CHANGE_PAGE;
      searchText: string;
      filters: Array<Filter>;
      organizationId: Organization['id'] | null;
      sort: Sort;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_LOADING;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_ERROR;
      error: any;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_LOAD_COMPLETE;
      items: Array<MultiPointInstallation>;
      total: number;
      m2m_capture_group_enabled: boolean;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_SET_SEARCH_TEXT;
      text: string;
      organizationId: Organization['id'] | null;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_SET_FILTERS;
      filters: Array<Filter>;
      organizationId: Organization['id'] | null;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_SET_SORT;
      direction: 'none' | 'desc' | 'asc';
      column: null | string;
      organizationId: Organization['id'] | null;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_CHANGE_CHECKS;
      ids: Array<MultiPointInstallation['id']>;
      checked: boolean;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_OPEN_SIDE_PANE;
      id: MultiPointInstallation['id'];
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_CLOSE_SIDE_PANE;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_DELETE;
      organizationId: Organization['id'] | null;
      id: MultiPointInstallation['id'];
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_SET_PAGE;
      value: number;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_LOADING;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_ERROR;
      error: string;
    }
  | {
      type: MultiPointInstallationListActionTypes.MULTI_POINT_INSTALLATION_LIST_NEXT_PAGE_LOAD_COMPLETE;
      mpis: Array<MultiPointInstallation>;
    };
